// @ts-nocheck
import React, { ReactElement, ReactNode, useEffect, useRef } from 'react';

export interface NavigationVerticalProps {
  /** If the vertical nav is open, this will move the focus to within the overlay panel */
  isOpen?: boolean;
  /** Passed down from the `HeaderNavigation` component */
  className?: string;
  /** Children to display within the `HeaderNavigation` */
  children?: ReactNode;
}

/**
 * Used within the `HeaderNavigation` component when the nav items are displayed in desktop mode.
 * Moves the logic focusing on the overlay away from other components.
 * @memberof Internal-Component
 */
export const NavigationVertical = ({ isOpen, className, children }: NavigationVerticalProps): ReactElement => {
  const listRef = useRef(null);

  useEffect((): void | (() => void) => {
    const { current } = listRef;
    if (!isOpen || !listRef) return undefined;
    current.setAttribute('tabIndex', '0');
    //current.focus();
    return (): void => current?.removeAttribute('tabIndex');
  }, [isOpen]);

  return (
    <ul ref={listRef} className={className}>
      {children}
    </ul>
  );
};
